import React, { useState } from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ rating, onRatingChange, interactive = false, size = 'md' }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const handleClick = (value) => {
    if (interactive && onRatingChange) {
      onRatingChange(value);
    }
  };

  const renderStar = (index) => {
    const value = index + 1;
    const displayRating = interactive && hoverRating > 0 ? hoverRating : rating;
    const isFilled = value <= displayRating;

    return (
      <button
        key={index}
        type="button"
        onClick={() => handleClick(value)}
        onMouseEnter={() => interactive && setHoverRating(value)}
        onMouseLeave={() => interactive && setHoverRating(0)}
        disabled={!interactive}
        className={`
          ${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'}
          transition-transform duration-150
        `}
        data-testid={`star-${value}`}
      >
        <Star
          className={`
            ${sizeClasses[size]}
            ${isFilled
              ? 'fill-legacy-gold text-legacy-gold'
              : 'text-stone-300'
            }
          `}
        />
      </button>
    );
  };

  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[0, 1, 2, 3, 4].map(renderStar)}
    </div>
  );
};

export default StarRating;
